import http from 'axios'
import { formatFiltresToAxiosParams } from './utils/filtres.utils'

export default {
  findAllTypesCulturesActiveByRs3: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/by-rs3/${codeGraineRs3}`)
  },
  getAllCulturesByNumtiers: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}`)
  },
  createCulture: (username, culture) => {
    return http.post(`/web/v1/${username}/culture`, culture)
  },
  updateCulture: (username, culture) => {
    return http.put(`/web/v1/${username}/culture`, culture)
  },
  deleteCulture: (username, id) => {
    return http.delete(`/web/v1/${username}/culture/${id}`)
  },
  getPoidsGraineConseilleCulture: (username, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/poids-conseille?codeTypeCulture=${codeTypeCulture}`)
  },
  getLibelleTypeCultureFeuillesGrainePrincipaleByTypeCultureFeuille: (codeTypeCulture) => {
    return http.get(`/web/v1/type-culture/cultures-graine-principale/${codeTypeCulture}`)
  },
  getAllCulturesSansMouvementByNumtiersAndRecolte: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/sans-mouvement`)
  },
  getRepartitionDesSurfaces: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/repartition`)
  },
  getRepartitionDesSurfacesGroupe: (username, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/repartition/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionDesGrandesCultures: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/grandes-cultures/repartition`)
  },
  getRepartitionDesGrandesCulturesGroupe: (username, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/grandes-cultures/repartition/groupe?${formatFiltresToAxiosParams(filtres)}`)
  }
}
